// extracted by mini-css-extract-plugin
module.exports = {"badge":"loader_badge__y2AsV","badgeTagSmall":"loader_badgeTagSmall__3_IxY","badgeTag":"loader_badgeTag__3T_ET"};